import { useInfiniteQuery } from '../use-query';
import { extendContainerValidator } from '../../utils';
import { repairService } from '../../services';
import { TABLE } from '../../const';

export const useRepairsGroupQuery = (keys: any = {}) => {
  if (keys.number?.length < 3 || !extendContainerValidator(keys.number)) {
    delete keys.number;
  }

  const result = useInfiniteQuery(
    ['repairs', 'group', JSON.stringify(keys)],
    ({ pageParam = 0 }) =>
      repairService
        .getAllGroup({
          params: {
            ...keys,
            take: TABLE.PAGE_MAX_SIZE,
            skip: pageParam * TABLE.PAGE_MAX_SIZE,
            onlyActive: true,
            notLoading: true,
          },
        })
        .then((res) => ({ ...res.data, pageParam })),
    {
      getNextPageParam: (data: any) => {
        const loaded = (data.pageParam + 1) * TABLE.PAGE_MAX_SIZE;
        return loaded < data.totalCount ? data.pageParam + 1 : undefined;
      },
      select: (data: any) => ({
        ...data,
        data: data.pages.flatMap((page: any) => page.data),
        totalCount: data.pages[0]?.totalCount ?? 0,
      }),
      keepPreviousData: false,
    },
  );

  return { ...result, data: result?.data || { data: [], totalCount: 0 } };
};

export const useRepairsQuery = (keys: any = {}) => {
  if (keys.number?.length < 3 || !extendContainerValidator(keys.number)) {
    delete keys.number;
  }

  const result = useInfiniteQuery(
    ['repairs', JSON.stringify(keys)],
    ({ pageParam = 0 }) =>
      repairService
        .getAll({
          params: {
            ...keys,
            take: TABLE.PAGE_MAX_SIZE,
            skip: pageParam * TABLE.PAGE_MAX_SIZE,
            onlyActive: true,
            notLoading: true,
          },
        })
        .then((res) => ({ ...res.data, pageParam })),
    {
      getNextPageParam: (data: any) => {
        const loaded = (data.pageParam + 1) * TABLE.PAGE_MAX_SIZE;
        return loaded < data.totalCount ? data.pageParam + 1 : undefined;
      },
      select: (data: any) => ({
        ...data,
        data: data.pages.flatMap((page: any) => page.data),
        totalCount: data.pages[0]?.totalCount ?? 0,
      }),
      keepPreviousData: false,
    },
  );

  return { ...result, data: result?.data || { data: [], totalCount: 0 } };
};
